import { Injectable, Inject } from '@angular/core';
import { Action, ScannedActionsSubject } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { Operator } from 'rxjs/Operator';
import { filter } from 'rxjs/operator/filter';
export class Actions<V = Action> extends Observable<V> {
/**
 * @param {?=} source
 */
constructor( source?: Observable<V>) {
    super();

    if (source) {
      this.source = source;
    }
  }
/**
 * @template R
 * @param {?} operator
 * @return {?}
 */
lift<R>(operator: Operator<V, R>): Observable<R> {
    const /** @type {?} */ observable = new Actions<R>();
    observable.source = this;
    observable.operator = operator;
    return observable;
  }
/**
 * @template V2
 * @param {...?} allowedTypes
 * @return {?}
 */
ofType<V2 extends V = V>(...allowedTypes: string[]): Actions<V2> {
    return filter.call(this, (action: Action) =>
      allowedTypes.some(type => type === action.type)
    );
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Observable, decorators: [{ type: Inject, args: [ScannedActionsSubject, ] }, ]},
];
}

function Actions_tsickle_Closure_declarations() {
/** @type {?} */
Actions.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Actions.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../modules/effects/src/actions.ts